import {EditInfoFooter} from "../../Components/Footers";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import PdfInput from "../../Components/UploadFiles/PdfInput";
import usePortalService from "../../services/PortalService";
import { useRef } from "react";
import { Diploma } from "../../types";
import ErrorMessage from "../../Components/Errors/ErrorMessage";
 
type DiplomasProps = {
  isBottom: boolean;
  handleFooter: () => void;
}

export const Diplomas = ({isBottom, handleFooter}: DiplomasProps) => {
  const certificatesRef = useRef<any>(null);

  const {getCertificates} = usePortalService();

  const [isCertificatesLoad, setIsSertificatesLoad] = useState(false);
  const [diplomas, setDiplomas] = useState<Diploma[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [errorDescription, setErrorDescription] = useState<string>('');

  const navigate = useNavigate()

  useEffect(() => {
    if (!isCertificatesLoad) {
      getCertificates().then(result => {
        if (result.success) {
          setDiplomas(result.certificates);
        }
      })
    }
    handleFooter()
  },[])

  const onSave = async () => {
    if (certificatesRef.current) {
        try {
          setErrorMessage("");
          await certificatesRef.current.save();
          navigate('/home')
        }
        catch (error) {
          if (error instanceof Error) {
            if (error.name === "SizeError") {
              setErrorMessage("Ошибка! Превышен допустимый размер файлов для отправки.");
              setErrorDescription("Пожалуйста, загрузите файл меньшего размера." +
                  "Если вы загрузили несколько файлов, то попробуйте отправить их по отдельности.");
            }
          }
        }
    }

  }

  console.log(diplomas)

  return(
    <>
      <div style={{maxWidth: "700px"}}>
        <h2 style={{ marginBottom: '12px' }}> Дипломы </h2>
        <PdfInput
          filesInit={diplomas}
          ref={certificatesRef}
        />
      </div>
      <EditInfoFooter isBottom={isBottom} onSave={onSave} onCancel={() => navigate("/home")}/>
      {errorMessage && <ErrorMessage message={errorMessage} description={errorDescription} />}
    </>
  )
}